import React, { memo, useMemo } from 'react'
import { Table, Typography } from 'antd'
import {
  IOrderByMonthItemCalc,
  IOrderByMonthItemTotal,
  IOrdersByMonth,
} from '../../model/types/types'
import './styles.css'
import { getOrdersByMonthColumns } from './columns'

const { Title, Text } = Typography
interface OrdersByManagersTableProps {
  data?: IOrdersByMonth
}

const columns = getOrdersByMonthColumns(true)

/*
class OfficeGroup {
  orders: IOrderByMonthItem[] = []
  office: string
  total?: IOrderByMonthItemTotal
  constructor(name: string) {
    this.office = name
  }
  add(el: IOrderByMonthItem) {
    this.orders.push(el)
  }
}

const OrdersByMonthTableOld = (props: OrdersByManagersTableProps) => {
  const { data } = props
  if (!data) {
    return <Typography.Text>Сервер не может найти запрошенный ресурс. </Typography.Text>
  }
  const months = useMemo(() => Object.keys(data), [data])
  return (
    <div className="orders-by-months-tables">
      {months.map(month => {
        return (
          <Table
            title={() => <Title level={5}>{month}</Title>}
            key={month}
            dataSource={data[month].units}
            columns={columns}
            pagination={false}
            size="small"
            style={{ marginBottom: '40px' }}
            // rowClassName={(record, i) => {
            //   return record?.manager?.includes('Итог') ? 'row-bold' : ''
            // }}ы
            summary={() => (
              <Table.Summary fixed>
                <Table.Summary.Row>
                  {columns.map((col, index) => {
                    const key = col.dataIndex
                    const val = data[month].total[key]
                    return (
                      <Table.Summary.Cell key={key} index={index}>
                        <Text strong>{val}</Text>
                      </Table.Summary.Cell>
                    )
                  })}
                </Table.Summary.Row>
              </Table.Summary>
            )}
          />
        )
      })}
    </div>
  )
}
*/

const OneTable = ({
  month,
  managers,
  offices,
  total
}: {
  month: string
  managers: IOrderByMonthItemCalc[]
  offices: IOrderByMonthItemCalc[]
  total: IOrderByMonthItemTotal
}) => {
  return (
    <Table
      title={() => <Title level={5}>{month}</Title>}  
      dataSource={[...managers, ...offices]}
      columns={columns}
      pagination={false}
      size='small'
      style={{ marginBottom: '40px' }}
      rowClassName={({manager }) => {
        return manager?.includes('Итог') ? 'row-bold' : ''
      }}
      summary={() => (
        <Table.Summary fixed>
          <Table.Summary.Row>
            {columns.map((col, index) => {
              const key = col.dataIndex
              const val = total[key]
              return (
                <Table.Summary.Cell key={key} index={index}>
                  <Text strong>{val}</Text>
                </Table.Summary.Cell>
              )
            })}
          </Table.Summary.Row>
        </Table.Summary>
      )}
    />
  )
}

const OrdersByMonthTable = (props: OrdersByManagersTableProps) => {
  const { data } = props
  if (!data) {
    return <Typography.Text>Сервер не может найти запрошенный ресурс. </Typography.Text>
  }

  const monthNames = {
    'Январь': 0,
    'Февраль': 1,
    'Март': 2,
    'Апрель': 3,
    'Май': 4,
    'Июнь': 5,
    'Июль': 6,
    'Август': 7,
    'Сентябрь': 8,
    'Октябрь': 9,
    'Ноябрь': 10,
    'Декабрь': 11,
  }

  const months = useMemo(() => {
    return Object.keys(data).sort((a, b) => {
      const [aMonth, aYear] = a.split(' ')
      const [bMonth, bYear] = b.split(' ')

      const aDate = new Date(Number(aYear), monthNames[aMonth])
      const bDate = new Date(Number(bYear), monthNames[bMonth])

      return bDate.getTime() - aDate.getTime()
    })
  }, [data])

  return (
    <div className='orders-by-months-tables'>
      {months.map((month, i) => {
        const dataS = data[month]
        return (
          <OneTable
            month={month}
            managers={dataS.managers}
            offices={dataS.offices}
            total={dataS.total}
            key={month + i}
          ></OneTable>
        )
      })}
    </div>
  )
}

export default memo(OrdersByMonthTable)
